<template>
  <div style="min-height: 45vh;">
    <div style="padding-bottom: 3%;" class="adway_subheaders">Step 3 / 4: Tell us about your driving</div>
    <div class="input-area">
      <div class="input-field-area">
        <div class="adway_input_filed_headers">How many hours do you drive weekly?</div>
        <input class="input-filed" type="text" :oninput="rangeValue()" onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))" placeholder="eg. 80 Hours" v-model="driverHours">
      </div>
      <div class="input-field-area">
        <div class="adway_input_filed_headers">When do you usually drive?</div>
        <div class="driver-time-checkbox">
          <div v-for="(element, item) in store.state.schema.ride_time" v-bind:key="item" class="selective__options">
            <button class="button-checkbox button-checkbox-text" @click="changeFlagValue(item, 1)" v-bind:class="[timeFlags[item] ? 'button-checkbox-active' : '']">{{element}}</button>
          </div>
        </div>
      </div>
      <div class="input-field-area" style="margin-top: 10px;">
        <div class="adway_input_filed_headers">What platform do you drive for?</div>
        <div class="driver-platoform-checkbox">
          <div v-for="(element, item) in store.state.schema.transportation_platform" v-bind:key="item" class="selective__options">
            <button class="button-checkbox button-checkbox-text" @click="changeFlagValue(item, 2)" v-bind:class="[platformFlags[item] ? 'button-checkbox-active' : '']">{{element}}</button>
          </div>
        </div>
      </div>
      <div class="password-area">
        <div class="adway_input_filed_headers">Where do you usually drive?</div>
        <div class="input-field-area password-inline" style="margin-top: 10px;">
          <select placeholder="State" class="input-filed selection__size" name="us state" v-model="usState"  style="height: 34px;width: 253px;"  @change="checkStateCities" @blur="checkStateCities">
            <option disabled value="">Please select one</option>
            <option v-for="us_state in store.state.schema.US" v-bind:key="us_state.state">{{us_state.state}}</option>
          </select>
        </div>
        <div class="input-field-area password-inline" style="margin-top: 10px;">
          <select placeholder="City" class="input-filed selection__size" name="state cities" v-model="usCity">
            <option disabled value="">Please select one</option>
            <option v-for="city in cities" v-bind:key="city">{{city}}</option>
          </select>
        </div>
          <!-- <input class="input-filed" type="text" placeholder="eg. Prius" v-model="carModel" > -->
      </div>
    </div>
  </div>
</template>

<script>
import store from '@store/index.js'
import { mapGetters } from 'vuex'
export default {
  name: 'DrivingInfo',
  data: function () {
    return {
      driverHours: this.driver.drivingHours,
      timeFlags: [],
      platformFlags: [],
      store: store,
      flagsIndex: this.driver.drivingTime,
      platformIndex: this.driver.drivingPlatform,
      cities: [],
      usCity: this.driver.usCity,
      usState: this.driver.usState,
    }
  },
  props: {
    driver: Object
  },
  beforeMount(){
       if(this.usState != null){
        this.checkStateCities();
      }
  },
  methods: {
    rangeValue () {
      if (this.driverHours > 80) {
        this.driverHours = 80
      }
      if (this.driverHours < 0) {
        this.driverHours = 0
      }
    },
    preload() {

    },
    changeSomeDriverSettings () {
      this.driver.drivingHours = this.driverHours
      this.driver.usCity = this.usCity
      this.driver.usState = this.usState
      this.driver.drivingTime = this.getTimeArray()
      this.driver.drivingPlatform = this.getPlatformArray()
      this.$emit('changeDriver', this.driver)
    },
    getTimeArray () {
      let array = []
      for (let index = 0 ; index < this.timeFlags.length ; index++){
        if (this.timeFlags[index]){
          array.push(this.schema.ride_time[index])
        }
      }
      return array
    },
    getPlatformArray () {
      let array = []
      for (let index = 0 ; index < this.platformFlags.length ; index++){
        if (this.platformFlags[index]){
          array.push(this.schema.transportation_platform[index])
        }
      }
      return array
    },
    changeFlagValue (index, array) {
      if (array === 1) {
        this.timeFlags.splice(index, 1, !this.timeFlags[index])
      } else if (array === 2) {
        this.platformFlags.splice(index, 1, !this.platformFlags[index])
      }
    },
    setFlagsArray () {
      this.schema.ride_time.forEach(element => {
        this.timeFlags.push(false)
      })
      this.schema.transportation_platform.forEach(element => {
        this.platformFlags.push(false)
      })
      this.flagsIndex?.forEach(element => {
        this.timeFlags[this.schema.ride_time.indexOf(element)] = true
      })
      this.platformIndex?.forEach(element => {
        this.platformFlags[this.schema.transportation_platform.indexOf(element)] = true
      })
    },
     checkStateCities () {
      store.state.schema.US.forEach(us => {
        if (us.state === this.usState) {
          this.cities = us.cities
        }
      })
    },
  },
  created: function () {
    this.setFlagsArray()
  },
  computed: {
    ...mapGetters({
      schema: 'getSchema'
    })
  }
}
</script>
